import axios from "axios";
import { useSelector } from "react-redux";
import key from "../key";

const PayButton = ({ data }) => {
  const { user } = useSelector((state) => state.user);

  const handleCheckout = async() => {
    await axios
      .post(`${key}/api/stripe/create-checkout-session`, {
        data,
        userId: user._id,
      })
      .then((response) => {
        if (response.data.url) {
          window.location.href = response.data.url;
        }
      })
      .catch((err) => console.log(err.message));
  };

  return (
    <>
      <button className="pricing-action" onClick={() => handleCheckout()}>Subscribe</button>
    </>
  );
};

export default PayButton;
